import button from './button';
import container from './container';
import rte from './rte';

export const components = (theme: any) => ({
  button: button(theme),
  container: container(theme),
  rte: rte(theme),
});
